import { render, staticRenderFns } from "./NavbarNav.vue?vue&type=template&id=1b8e3c2d&scoped=true&"
import script from "./NavbarNav.vue?vue&type=script&lang=js&"
export * from "./NavbarNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8e3c2d",
  null
  
)

export default component.exports